// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__bmHTT","buttons":"RemoveExpirationActionButtons_buttons__2KH2G"};